import React from 'react';
import { Hero } from '../components/Hero';
import { PainPoints } from '../components/PainPoints';
import { ProgramDetails } from '../components/ProgramDetails';
import { Curriculum } from '../components/Curriculum';
import { SocialProof } from '../components/SocialProof';
import { Pricing } from '../components/Pricing';
import { FinalClose } from '../components/FinalClose';
import { SalesNotifications } from '../components/shared/SalesNotifications';
export function LandingPage() {
  return <main className="min-h-screen w-full bg-[#FFF8F0]" data-id="element-273">
      <Hero data-id="element-274" />
      <PainPoints data-id="element-275" />
      <ProgramDetails data-id="element-276" />
      <Curriculum data-id="element-277" />
      <SocialProof data-id="element-278" />
      <Pricing data-id="element-279" />
      <FinalClose data-id="element-280" />
      <SalesNotifications data-id="element-281" />
    </main>;
}